import { useState } from "react";
import ColumnMappingRow from "./ColumnMappingRow";
import ColumnMappingHeader from "./ColumnMappingHeader";

export default function ColumnMappingTable({
  mappings,
  file2Cols,
  rules,
  autoMap,
  updateMapping,
  moveTop,
  moveUp,
  moveDown,
  removeRow,
  saveConfig,
  setIsEditMode,
  isEditMode,
  showEdit
}) {

  const [isExpanded, setIsExpanded] = useState(false);
  return (
     <div
        className={
          isExpanded
            ? "fixed inset-4 z-50 bg-white rounded-xl shadow-2xl flex flex-col transition-all duration-300"
            : "bg-white border rounded-xl overflow-hidden mb-6 shadow-sm transition-all duration-300"
        }
      >
      {/* HEADER */}
        <ColumnMappingHeader
          title="Column Mapping"
          expanded={isExpanded}
          editable={isEditMode}
          onAutoMap={autoMap}
          onToggleExpand={() =>
            setIsExpanded(!isExpanded)
          }
          showEdit={showEdit}
          extraActions={
            isEditMode  ? (
              <>
                <button
                  onClick={saveConfig}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg"
                >
                  Save
                </button>

                <button
                  onClick={()=>setIsEditMode(false)}
                  className="px-4 py-2 border rounded-lg"
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                onClick={() => setIsEditMode(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg"
              >
                Edit
              </button>
            )
          }
        />

      <div  className={isExpanded ? "flex-1 overflow-auto" : "max-h-[500px] overflow-auto"}>
        <table className="w-full text-sm table-fixed">

          <thead className="bg-gray-100 sticky top-0 z-10 shadow-sm text-xs uppercase">
            <tr>
              <th className="w-[180px] px-4 py-3 text-left sticky left-0 bg-gray-100">
                Source
              </th>

              <th className="w-[40px]"></th>

              <th className="w-[180px]">
                Target
              </th>

              <th className="w-[80px]">
                Unique
              </th>

              <th className="w-[80px]">
                Display
              </th>

              <th className="w-[120px]">
                Payment Party
              </th>

              <th className="w-[80px]">
                Final Output
              </th>

              <th className="w-[80px]">
                Master
              </th>

              <th className="w-[80px]">
                Input
              </th>

              <th className="w-[80px]">
                Custom
              </th>

              <th className="w-[80px]">
                Output
              </th>

              <th className="w-[100px]">
                Type
              </th>

              <th className="w-[100px]">
                Diff
              </th>

              <th className="w-[200px]">
                Transform Rule
              </th>

              <th className="w-[160px]">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {mappings.map(
              (mapping, index) => (
                <ColumnMappingRow
                  key={index}
                  mapping={mapping}
                  index={index}
                  file2Cols={file2Cols}
                  rules={rules}
                  updateMapping={
                    updateMapping
                  }
                  moveTop={moveTop}
                  moveUp={moveUp}
                  moveDown={moveDown}
                  removeRow={removeRow}
                  editable={isEditMode}
                />
              )
            )}
          </tbody>

        </table>
      </div>
    </div>
  );
}